module.exports = __webpack_public_path__ + "media/images/magnifying-glass-plus-solid-7037692c89b6e330be30fa4301b4ec43.svg";